import { useLanguage } from "@digipost/translate";

import { TranslateFunction, translator } from "./translator";

const DEFAULT_LANGUAGE = "nb";

export const useTranslate = (): TranslateFunction => {
  const { language: contextLanguage } = useLanguage();

  return (
    textKey,
    params,
    providedLanguages,
    language = contextLanguage || DEFAULT_LANGUAGE,
  ) => translator.translate(language, textKey, params, providedLanguages);
};
